<template>
  <div class="page">
    <Steps v-if="assistanceStep && assistanceStep !== 'type'" />
    <div class="loading" v-if="loading">
      <h3 class="title">
        Sprawa jest w trakcie rejestrowania.
        <br />Za chwilę dostaniesz jej numer.
      </h3>
      <div class="spinner">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M22.1491 0.113824C22.9231 0.0384958 23.7073 0 24.5 0C25.2927 0 26.0769 0.0384957 26.8509 0.113824C27.9503 0.220816 28.7548 1.19877 28.6478 2.29815C28.5408 3.39752 27.5629 4.20201 26.4635 4.09501C25.818 4.0322 25.1631 4 24.5 4C23.8369 4 23.182 4.0322 22.5365 4.09501C21.4371 4.20201 20.4592 3.39752 20.3522 2.29815C20.2452 1.19877 21.0497 0.220816 22.1491 0.113824ZM36.9116 5.72346C37.6128 4.87001 38.8731 4.7466 39.7265 5.44781C40.9405 6.44524 42.0548 7.55949 43.0522 8.77348C43.7534 9.62693 43.63 10.8872 42.7765 11.5884C41.9231 12.2896 40.6628 12.1662 39.9616 11.3128C39.1295 10.3001 38.1999 9.37048 37.1872 8.53843C36.3338 7.83722 36.2103 6.57691 36.9116 5.72346ZM12.0884 5.72347C12.7896 6.57692 12.6662 7.83722 11.8128 8.53843C10.8001 9.37048 9.87048 10.3001 9.03843 11.3128C8.33722 12.1662 7.07691 12.2897 6.22346 11.5884C5.37001 10.8872 5.2466 9.62693 5.94781 8.77348C6.94524 7.5595 8.05949 6.44524 9.27348 5.44781C10.1269 4.7466 11.3872 4.87002 12.0884 5.72347ZM46.2019 19.8522C47.3012 19.7452 48.2792 20.5497 48.3862 21.6491C48.4615 22.4231 48.5 23.2073 48.5 24C48.5 24.7927 48.4615 25.5769 48.3862 26.3509C48.2792 27.4503 47.3012 28.2548 46.2019 28.1478C45.1025 28.0408 44.298 27.0629 44.405 25.9635C44.4678 25.318 44.5 24.6631 44.5 24C44.5 23.3369 44.4678 22.682 44.405 22.0365C44.298 20.9371 45.1025 19.9592 46.2019 19.8522ZM2.79815 19.8522C3.89752 19.9592 4.70201 20.9371 4.59501 22.0365C4.5322 22.682 4.5 23.3369 4.5 24C4.5 24.6631 4.5322 25.318 4.59501 25.9635C4.70201 27.0629 3.89752 28.0408 2.79815 28.1478C1.69877 28.2548 0.720816 27.4503 0.613824 26.3509C0.538496 25.5769 0.5 24.7927 0.5 24C0.5 23.2073 0.538496 22.4231 0.613824 21.6491C0.720816 20.5497 1.69877 19.7452 2.79815 19.8522ZM42.7765 36.4116C43.63 37.1128 43.7534 38.3731 43.0522 39.2265C42.0548 40.4405 40.9405 41.5548 39.7265 42.5522C38.8731 43.2534 37.6128 43.13 36.9116 42.2765C36.2104 41.4231 36.3338 40.1628 37.1872 39.4616C38.1999 38.6295 39.1295 37.6999 39.9616 36.6872C40.6628 35.8338 41.9231 35.7103 42.7765 36.4116ZM6.22347 36.4116C7.07692 35.7104 8.33722 35.8338 9.03843 36.6872C9.87048 37.6999 10.8001 38.6295 11.8128 39.4616C12.6662 40.1628 12.7897 41.4231 12.0884 42.2765C11.3872 43.13 10.1269 43.2534 9.27348 42.5522C8.0595 41.5548 6.94524 40.4405 5.94781 39.2265C5.2466 38.3731 5.37002 37.1128 6.22347 36.4116ZM28.6478 45.7019C28.7548 46.8012 27.9503 47.7792 26.8509 47.8862C26.0769 47.9615 25.2927 48 24.5 48C23.7073 48 22.9231 47.9615 22.1491 47.8862C21.0497 47.7792 20.2452 46.8012 20.3522 45.7019C20.4592 44.6025 21.4371 43.798 22.5365 43.905C23.182 43.9678 23.8369 44 24.5 44C25.1631 44 25.818 43.9678 26.4635 43.905C27.5629 43.798 28.5408 44.6025 28.6478 45.7019Z"
            :fill="$color"
          />
        </svg>
        <div class="dot" :style="{ background: $color }" />
      </div>
    </div>
    <div v-else :class="clName">
      <div class="container" v-if="!activePage">
        <h3 class="title">W czym możemy pomóc?</h3>
        <div class="list">
          <div
            class="item"
            v-for="(item, i) in items"
            v-if="item.show"
            :key="i"
            @click="itemClick({ hasModal: item.modal, name: item.name, link: item.link })"
          >
            <div class="image" :style="{ background: $color }">
              <img :src="item.image" alt />
            </div>
            <p class="text" :style="{ color: $color }">
              {{item.title}}
              <svg
                width="6"
                height="16"
                viewBox="0 0 6 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M0.247078 0.914727C0.51507 0.719824 0.89032 0.779075 1.08522 1.04707L5.88522 7.64707C6.03823 7.85746 6.03823 8.14248 5.88522 8.35287L1.08522 14.9529C0.89032 15.2209 0.51507 15.2801 0.247078 15.0852C-0.0209133 14.8903 -0.0801633 14.5151 0.11474 14.2471L4.65808 7.99997L0.11474 1.75287C-0.0801633 1.48488 -0.0209133 1.10963 0.247078 0.914727Z"
                  :fill="$color"
                />
              </svg>
            </p>
          </div>
        </div>
        <modal name="case-modal" :width="500">
          <form @submit.prevent="setUserNumber">
            <button type="button" class="modal-close" @click="$modal.hide('case-modal')">
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14.5999 1.40002L7.9999 8.00002M1.3999 14.6L7.9999 8.00002M7.9999 8.00002L1.3999 1.40002M7.9999 8.00002L14.5999 14.6"
                  :stroke="$color"
                  stroke-width="2"
                  stroke-linecap="round"
                />
              </svg>
            </button>
            <h3 class="modal-title">CO Z MOJĄ SPRAWĄ?</h3>
            <h4 class="modal-subtitle">Podaj numer sprawy</h4>
            <div class="field">
              <input type="text" class="input" v-model="number" />
              <button type="submit" class="arrow">
                <svg
                  width="24"
                  height="18"
                  viewBox="0 0 24 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.3415 0.247437C15.7571 -0.116245 16.3889 -0.0741276 16.7526 0.341509L23.7526 8.34151C24.0825 8.71853 24.0825 9.28149 23.7526 9.65852L16.7526 17.6585C16.3889 18.0742 15.7571 18.1163 15.3415 17.7526C14.9259 17.3889 14.8837 16.7571 15.2474 16.3415L20.7962 10H1C0.447715 10 0 9.5523 0 9.00001C0 8.44773 0.447715 8.00001 1 8.00001H20.7962L15.2474 1.65852C14.8837 1.24288 14.9259 0.611119 15.3415 0.247437Z"
                    :fill="$color"
                  />
                </svg>
              </button>
            </div>
          </form>
        </modal>

        <MissingDataModal :bus="bus"/>
      </div>
      <Result v-if="activePage === 'caseResult'" @changeActivePage="setActivePage" />
      <Result is-accepted v-if="activePage === 'caseResultSuccess'" @changeActivePage="setActivePage" />
      <NoResult v-if="activePage === 'caseNoResult'" @changeActivePage="setActivePage" />
      <div v-if="activePage === 'assistance'">
        <StepType v-if="assistanceStep === 'type'" @setStep="setAssistanceStep" />
        <StepVerification
          v-if="assistanceStep === 'home' || assistanceStep === 'help' || assistanceStep === 'car'"
          @setStep="setAssistanceStep"
          :activeStep="assistanceStep"
        />
        <StepHomeType v-if="assistanceStep === 'homeType'" @setStep="setAssistanceStep" />
        <StepResult v-if="assistanceStep === 'result'" :activeStep="assistanceStep" />
        <AssistanceNoResult v-if="assistanceStep === 'noResult'" />
        <StepMedicalType v-if="assistanceStep === 'medicalType'" />
        <StepHomeSpecialist v-if="assistanceStep === 'homeSpecialist'" />
        <StepAdditional v-if="assistanceStep === 'additional'" />
        <StepOtherService v-if="assistanceStep === 'otherService'" />
        <StepLast v-if="assistanceStep === 'last'" />
        <StepAdditionalDescription v-if="assistanceStep === 'additionalDescription'" />
        <StepHomeRepair v-if="assistanceStep === 'homeRepair'" />
        <StepHomeRepairVendor v-if="assistanceStep === 'homeRepairVendor'" />
        <StepHomeRepairModel v-if="assistanceStep === 'homeRepairModel'" />
        <StepHomeRepairPhoto v-if="assistanceStep === 'homeRepairPhoto'" />
        <StepMedicalOther v-if="assistanceStep === 'medicalOther'" />
        <StepMedicalHome v-if="assistanceStep === 'medicalHome'" />
        <StepMedicalSymptoms v-if="assistanceStep === 'medicalSymptoms'" />
        <StepMedicalOtherPerson v-if="assistanceStep === 'medicalOtherPerson'" />
        <StepMedicalWasDoctor v-if="assistanceStep === 'wasDoctor'" />
        <DataSent v-if="assistanceStep === 'dataSent'" />
        <DataSentError v-if="assistanceStep === 'dataSentError'" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import item1 from "../assets/images/item_1.svg";
import item2 from "../assets/images/item_2.svg";
import item3 from "../assets/images/item_3.svg";
import item4 from "../assets/images/item_4.svg";
import item5 from "../assets/images/item_5.svg";
import Steps from "./Steps";
import Result from "./case_steps/Result";
import NoResult from "./case_steps/NoResult";
import StepType from "./assistance_steps/StepType";
import StepVerification from "./assistance_steps/StepVerification";
import StepHomeType from "./assistance_steps/StepHomeType";
import StepResult from "./assistance_steps/Result";
import StepHomeSpecialist from "./assistance_steps/StepHomeSpecialist";
import StepAdditional from "./assistance_steps/StepAdditional";
import StepLast from "./assistance_steps/StepLast";
import DataSent from "./assistance_steps/DataSent";
import DataSentError from "./assistance_steps/DataSentError";
import StepAdditionalDescription from "./assistance_steps/StepAdditionalDescription";
import StepHomeRepair from "./assistance_steps/StepHomeRepair";
import StepHomeRepairVendor from "./assistance_steps/StepHomeRepairVendor";
import StepHomeRepairModel from "./assistance_steps/StepHomeRepairModel";
import StepHomeRepairPhoto from "./assistance_steps/StepHomeRepairPhoto";
import StepMedicalType from "./assistance_steps/StepMedicalType";
import StepMedicalOther from "./assistance_steps/StepMedicalOther";
import StepMedicalHome from "./assistance_steps/StepMedicalHome";
import StepMedicalSymptoms from "./assistance_steps/StepMedicalSymptoms";
import StepMedicalOtherPerson from "./assistance_steps/StepMedicalOtherPerson";
import AssistanceNoResult from "./assistance_steps/NoResult";
import StepMedicalWasDoctor from "./assistance_steps/StepMedicalWasDoctor";
import StepOtherService from "./assistance_steps/StepOtherService";
import Vue from "vue";
import MissingDataModal from "./shared/MissingDataModal";

export default {
  name: "Home",
  data() {
    return {
      items: [
        {
          title: this.$saxId === "932" ? "USŁUGI MEDYCZNE" : "Pomoc assistance",
          name: "assistance",
          show: true,
          image: item1,
        },
        {
          title: this.$saxId === "932" ? "KONTAKT Z CENTRUM OPERACYJNYM" : "Kontakt z Centrum Alarmowym",
          image: item2,
          show: true,
          link: `tel:${this.$phone}`,
        },
        {
          title: "Co z moją sprawą?",
          image: item3,
          show: true,
          modal: true,
        },
        {
          title: "Zgłoszenie szkody CA Ubezpieczenia",
          image: item4,
          show: this.$saxId === '974',
          link:
            "https://www.ca-ubezpieczenia.pl/obsluga/zgloszenie-szkody",
        },
        {
          title: "Polityka prywatności",
          image: item5,
          show: true,
          link: "https://www.redion.com/pl/o-nas/",
        },
      ],
      number: "",
      clName: document.title === "Pakiet niezawodny" ? "main" : "",

      bus: new Vue(),
    };
  },
  methods: {
    ...mapMutations([
      "setUserData",
      "setActivePage",
      "setAssistanceStep",
      "setNumber",
      "setSaxId",
      "setStep"
    ]),
    itemClick({ hasModal, name, link }) {
      if (hasModal) {
        if (this.itemNumber) {
          this.setActivePage("caseResult");
        } else {
          this.$modal.show("case-modal");
        }
      }
      if (name) {
        this.setActivePage(name);
        if (this.$saxId === '932') {
          this.setAssistanceStep("help");
          this.setStep({ index: 0, step: { text: 'Weryfikacja', value: 'help' }}); // Fixed bug 9.6.2021
        } else {
          this.setAssistanceStep("type");
        }
      }
      if (link) {
        window.open(link);
      }
    },
    setUserNumber() {
      this.setNumber(this.number);
      this.bus.$emit('attemptSendUserQuestion')
      this.$modal.hide("case-modal");
    },
  },
  computed: {
    ...mapState([
      "activePage",
      "assistanceStep",
      "steps",
      "loading",
      "itemNumber",
    ]),
  },
  props: {
    title: {},
  },
  mounted() {
    // this.setUserData({SaxId: this.$saxId}); Nonono we don't want this. Instead we set sax ID from user data
  },
  components: {
    MissingDataModal,
    StepOtherService,
    StepMedicalWasDoctor,
    AssistanceNoResult,
    StepMedicalOtherPerson,
    StepMedicalSymptoms,
    StepMedicalHome,
    StepMedicalOther,
    StepMedicalType,
    StepHomeRepairPhoto,
    StepHomeRepairModel,
    StepHomeRepairVendor,
    StepHomeRepair,
    StepAdditionalDescription,
    DataSent,
    DataSentError,
    StepLast,
    StepAdditional,
    StepHomeSpecialist,
    StepResult,
    StepType,
    Result,
    NoResult,
    Steps,
    StepVerification,
    StepHomeType,
  },
};
</script>

<style scoped lang="scss">
.page {
  background: #e5e5e5;
  padding: 120px 0 32px;
  min-height: 100vh;
  @media screen and (max-width: 816px) {
    background: #fff;
    padding-top: 118px;
  }
}
.main {
  @media screen and (max-width: 470px) {
    margin-top: 30px;
  }
}
.spinner {
  position: relative;
  display: block;
  margin: 50px auto 0;
  width: 48px;
  height: 48px;
  svg {
    animation: rotate 1s ease infinite;
  }
  .dot {
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    top: 50%;
    left: 50%;
    margin: -8px 0 0 -8px;
    animation: dot 1s ease infinite;
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-180deg);
  }
  to {
    transform: rotate(0deg);
  }
}
@keyframes dot {
  from {
    width: 16px;
    height: 16px;
    margin: -8px 0 0 -8px;
  }
  50% {
    width: 32px;
    height: 32px;
    margin: -16px 0 0 -16px;
  }
  to {
    width: 16px;
    height: 16px;
    margin: -8px 0 0 -8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue